@if (orderPlanByPeriodLoaded$ | async) {
  <agr-page-detail
    [pageTitle]="('productInventory' | translate) + ' ' + (customer$ | async)?.name"
    [hasPrimaryAction]="hasCropAids === true"
    [isEmpty]="hasCropAids === false"
    (primaryAction)="print()"
    (backAction)="back()"
    primaryActionIcon="print"
    [emptyTitle]="'noProductsInInventory' | translate"
    [primaryActionText]="'print' | translate"
  >
    <agr-print-page [marginLeft]="true" [showPageNumber]="false">
      <div class="wrapper--spacing-horizontal">
        @if (hasCropAids === false) {
          <p class="screen-only">
            {{ 'noProductsInInventory' | translate }}
          </p>
        }
        @if (hasCropAids) {
          <table mat-table [dataSource]="cropAids$ | async">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ 'product' | translate }}</th>
              <td mat-cell *matCellDef="let cropAidData">
                <mat-icon [color]="getShortageAmount(cropAidData) ? 'warn' : 'primary'" class="spacing--margin-right">
                  {{ getShortageAmount(cropAidData) ? 'warning' : 'check' }}
                </mat-icon>
                {{ cropAidData.cropAid?.name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="requisite">
              <th mat-header-cell *matHeaderCellDef>{{ 'requisite' | translate }}</th>
              <td mat-cell *matCellDef="let cropAidData">
                {{ cropAidData.requisiteAmount | agrNumber: '1.0-2' }}
                {{ cropAidData.cropAid.unitOfMeasurement }}
              </td>
            </ng-container>
            <ng-container matColumnDef="inventory">
              <th mat-header-cell *matHeaderCellDef>{{ 'productInventory' | translate }}</th>
              <td mat-cell *matCellDef="let cropAidData">
                {{ cropAidData.customerProductInventoryAmount | agrNumber: '1.0-2' }}
                {{ cropAidData.cropAid.unitOfMeasurement }}
              </td>
            </ng-container>
            <ng-container matColumnDef="ordered">
              <th mat-header-cell *matHeaderCellDef>{{ 'order' | switchTranslation }}</th>
              <td mat-cell *matCellDef="let cropAidData">
                {{ cropAidData.orderLinesTotalAmount }}
                {{ cropAidData.cropAid.unitOfMeasurement }}
              </td>
            </ng-container>
            <ng-container matColumnDef="result">
              <th mat-header-cell *matHeaderCellDef>{{ 'result' | translate }}</th>
              <td mat-cell *matCellDef="let cropAidData">
                @if (getShortageAmount(cropAidData); as shortageAmount) {
                  <span class="text--error">
                    <span class="text--bold">-</span>
                    {{ shortageAmount | agrNumber: '1.0-2' }} {{ cropAidData.cropAid.unitOfMeasurement }}
                  </span>
                }
                @if (getExcessAmount(cropAidData); as excessAmount) {
                  <span class="text--warning">
                    <span class="text--bold">+</span> {{ excessAmount | agrNumber: '1.0-2' }}
                    {{ cropAidData.cropAid.unitOfMeasurement }}
                  </span>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        }
      </div>
    </agr-print-page>
  </agr-page-detail>
}
